<template>
<BasePage :container="false" class="main-container">

  <Loader v-if="loading"/>
  <Basic404 v-else-if="error">
    <p class="fs-8">Video not found </p>
    <p class="fs-6">Do you have access?</p>
  </Basic404>
  <VideoBase
    v-else
    :video="video"
  />
</BasePage>

</template>

<script>
import VideoBase from './VideoBase.vue'
import Loader from './Loader.vue'
import BasePage from './BasePage.vue'
import Basic404 from './Basic404.vue'

import store from '../store.js'

import {
  fetchVideoByID,
} from '../actionTypes'

export default {
  name: 'VideoByID',
  components: {
    VideoBase,
    Loader,
    BasePage,
    Basic404,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      // we neeed to start off loading otherwise we end up rendering the empty
      // component then switching to loading then back
      loading: true,
      error: false,
    }
  },
  async mounted () {
    try {
      await store.dispatch(fetchVideoByID, this.id)
    } catch (error) {
      this.error = true
    }
    this.loading = false
  },
  computed: {
    video () {
      return store.state.videos[this.id]
    },
  },
}
</script>



// WEBPACK FOOTER //
// VideoByID.vue?3d3615d8